import { atomWithObservable } from 'jotai/utils';
import { fromEvent, map, startWith } from 'rxjs';

// Observable that listens to Unity PodTapped events
const podTappedObservable = fromEvent<CustomEvent>(window, 'PodTapped').pipe(
  map((event) => {
    const podId = event.detail?.podId;
    console.log('PodTapped event received:', podId);
    return podId || null;
  }),
  startWith(null), // Start with null to prevent Suspense hanging
);

// Atom that updates when Unity sends PodTapped events
export const podTappedObservableAtom = atomWithObservable(
  () => podTappedObservable,
);

// Main atom for tracking tapped pod ID - simplified to directly use the observable atom
export const tappedPodIdAtom = podTappedObservableAtom;
